import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../../Icon';
import { ProgressCircle } from '../../ProgressCircle';
import styles from './styles.module.scss';

export const EmptyDropdownLabel = (props) => {
  const { searchTerm, isLoading, isError, className, classes } = props;

  if (isError) {
    return (
      <div className={`${styles.noSearchResultsWrapper} ${className || ''}`}>
        <Icon name="EmptyClipboard" className={`${styles.icon} ${classes?.icon || ''}`} />
        <div className={`${styles.mainTitle} ${classes?.mainTitle || ''}`}>Oops</div>
        <div className={`${styles.subtitle} ${classes?.subtitle || ''}`}>
          <div className="w-100">Something went wrong.</div>
          <div className="w-100">Please try again</div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`${styles.noSearchResultsWrapper} ${className || ''} ${
        isLoading ? styles.isLoading : ''
      }`}
    >
      {isLoading ? (
        <ProgressCircle className={styles.spinner} size={32} />
      ) : (
        <>
          <Icon name="EmptyClipboard" className={styles.icon} />
          <div className={`${styles.mainTitle} ${classes?.mainTitle || ''}`}>No results found</div>
          {searchTerm ? (
            <div className={`${styles.subtitle} ${classes?.subtitle || ''}`}>
              <span className={styles.searchMessage}>
                We can't find any items matching your search
              </span>
              <br />
              <div className={styles.searchTermWrapper}>
                <span className={styles.quote}>"</span>
                <span className={styles.searchTerm}>{searchTerm}</span>
                <span className={styles.quote}>".</span>
              </div>
            </div>
          ) : null}
        </>
      )}
    </div>
  );
};

EmptyDropdownLabel.propTypes = {
  searchTerm: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  isError: PropTypes.bool.isRequired,
  className: PropTypes.string,
  classes: PropTypes.shape({
    subtitle: PropTypes.string,
    mainTitle: PropTypes.string,
    icon: PropTypes.string,
  }),
};
